import { List } from 'dashboard/models/list';
import { ListItem } from 'dashboard/models/list-item';
import { ApiModel } from 'lib/interfaces/api';

export const LIST_TYPE_TO_LIST_ITEM_TYPE: Record<List['type'], ListItem['type']> = {
  [ApiModel.ListGovernmentIdNumber]: ApiModel.ListItemGovernmentIdNumber,
  [ApiModel.ListIpAddress]: ApiModel.ListItemIpAddress,
  [ApiModel.ListName]: ApiModel.ListItemName,
  [ApiModel.ListPhoneNumber]: ApiModel.ListItemPhoneNumber,
  [ApiModel.ListEmailAddress]: ApiModel.ListItemEmailAddress,
  [ApiModel.ListGeolocation]: ApiModel.ListItemGeolocation,
  [ApiModel.ListBrowserFingerprint]: ApiModel.ListItemBrowserFingerprint,
  [ApiModel.ListDeviceFingerprint]: ApiModel.ListItemDeviceFingerprint,
  [ApiModel.ListFace]: ApiModel.ListItemFace,
  [ApiModel.ListCountry]: ApiModel.ListItemCountry,
  [ApiModel.ListField]: ApiModel.ListItemField,
  [ApiModel.ListString]: ApiModel.ListItemString,
  [ApiModel.ListSelfieBackground]: ApiModel.ListItemSelfieBackground,
};

export const LIST_TYPE_NAMES: Record<List['type'], string> = {
  [ApiModel.ListGovernmentIdNumber]: 'Government ID number',
  [ApiModel.ListIpAddress]: 'IP address',
  [ApiModel.ListName]: 'Name',
  [ApiModel.ListPhoneNumber]: 'Phone number',
  [ApiModel.ListEmailAddress]: 'Email address',
  [ApiModel.ListGeolocation]: 'Geolocation',
  [ApiModel.ListBrowserFingerprint]: 'Browser fingerprint',
  [ApiModel.ListDeviceFingerprint]: 'Device fingerprint',
  [ApiModel.ListFace]: 'Face',
  [ApiModel.ListCountry]: 'Country',
  [ApiModel.ListField]: 'Inquiry field',
  [ApiModel.ListString]: 'String',
  [ApiModel.ListSelfieBackground]: 'Selfie background',
};

export const ENHANCED_LIST_TYPES = [ApiModel.ListFace, ApiModel.ListSelfieBackground];
